import { getContext, setContext } from 'svelte';
import { Themes, type ThemeKey, type ThemeType, standardKeys } from './ColorThemes.svelte';
import { objectToCssVariables } from './objectToCssVariables';

export type ThemeInitiator = number | string | ThemeKey | ThemeType;

export const getFromInitiator = (
	init?: null | ThemeInitiator
):
	| undefined
	| {
			data: ThemeType;
			name: string;
			from: 'number' | 'name' | 'data';
	  } => {
	if (typeof init === 'number') {
		const key = standardKeys[Math.abs(init % standardKeys.length)];
		const theme = Themes.get(key);
		if (!theme) return;
		return {
			data: theme,
			name: key,
			from: 'number'
		};
	} else if (typeof init === 'string') {
		const theme = Themes.get(init);
		if (!theme) return;
		return {
			data: theme,
			name: init,
			from: 'name'
		};
	} else if (init) {
		if ('secondary' in init && 'secondary' in init && 'foreground' in init) {
			return {
				data: {
					primary: init.primary,
					secondary: init.secondary,
					foreground: init.foreground
				},
				name: 'custom',
				from: 'data'
			};
		}
	}
};

class Theme {
	public name: string | undefined = undefined;
	public theme = $state<ThemeType | undefined>(undefined);
	public css = $derived(this.theme ? objectToCssVariables({ theme: this.theme }) : undefined);

	constructor(init?: ThemeInitiator | null) {
		const fromInit = getFromInitiator(init);
		if (!fromInit) {
			// this.theme = getContext<Theme | undefined>('theme')?.theme;
		} else {
			this.theme = fromInit.data;
			this.name = fromInit.name;
			setContext<Theme>('theme', this);
		}
	}

	public set(init?: ThemeInitiator | null) {
		const gotten = getFromInitiator(init);
		if (gotten) {
			this.theme = gotten.data;
			this.name = gotten.name;
		}
	}

	public static get name() {
		return getContext<Theme | undefined>('theme')?.name;
	}

	public static get current() {
		return getContext<Theme | undefined>('theme')?.theme;
	}

	public static get css() {
		return getContext<Theme | undefined>('theme')?.css;
	}

	public static set(init?: ThemeInitiator | null) {
		const context = getContext<Theme | undefined>('theme');
		if (!context) {
			console.warn('Attempted to get theme outside of context');
			return;
		}
		context.set(init);
	}

	public toString() {
		return this.css;
	}

	public static init(init?: ThemeInitiator | null) {
		const fromInit = getFromInitiator(init);

		return {
			theme: fromInit?.data,
			name: fromInit?.name,
			css: fromInit ? objectToCssVariables({ theme: fromInit.data }) : undefined
		};
	}
}

export default Theme;
